class StepUpEventEmitter {
  constructor() {
    this.listeners = new Map();
    this.pendingRequest = null;
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);

    return () => {
      const callbacks = this.listeners.get(event) || [];
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    };
  }

  emit(event, data) {
    const callbacks = this.listeners.get(event) || [];
    callbacks.forEach((cb) => cb(data));
  }

  requestStepUp(bucket, originalRequest) {
    return new Promise((resolve, reject) => {
      this.pendingRequest = { resolve, reject, originalRequest };
      this.emit("step-up-required", { bucket });
    });
  }

  resolveStepUp() {
    if (this.pendingRequest) {
      const { resolve } = this.pendingRequest;
      this.pendingRequest = null;
      resolve(true);
    }
  }

  rejectStepUp() {
    if (this.pendingRequest) {
      const { reject } = this.pendingRequest;
      this.pendingRequest = null;
      reject(new Error("Step-up cancelled"));
    }
  }

  getPendingRequest() {
    return this.pendingRequest?.originalRequest;
  }
}

export const stepUpEvents = new StepUpEventEmitter();
